/**
 * Default popup direction with respect to part title
 * @type {string}
 */
export const DEFAULT_DIRECTION = 'right';

/**
 * Default popup height in px
 * @type {number}
 */
export const POPUP_HEIGHT = 470;